import { useEffect, type ReactNode } from 'react'
import { startUserStream, signInAnonymouslyH2H, getCurrentUserUid } from '@/firebase/auth'
import { shellStore } from '@/store/shellStore'
import { appState } from '@/store/appState'
import { SPLASH_MS } from '@/config/constants'

/* Port of main() + _MyAppState.initState():
 *
 *   userStream = h2HWebAppFirebaseUserStream()..listen(update);
 *   jwtTokenStream.listen((_) {});
 *   Future.delayed(1000ms, () => stopShowingSplashImage());
 *
 * The splash timer is FIXED at 1000 ms and independent of auth: even an
 * instantly-restored session waits the full second behind the gate.
 *
 * The loading gate itself is applied PER ROUTE (FFRoute.pageBuilder), not
 * here — the 404 errorBuilder renders ungated. See router.tsx. */

let splashTimerStarted = false

export function FirebaseBootstrap({ children }: { children: ReactNode }) {
  useEffect(() => {
    startUserStream()
    if (!splashTimerStarted) {
      splashTimerStarted = true
      setTimeout(() => shellStore.stopShowingSplashImage(), SPLASH_MS)
    }
    if (import.meta.env.DEV) {
      // Dev hooks for browser-side verification.
      ;(window as unknown as Record<string, unknown>).__h2h = {
        shellStore,
        appState,
        signInAnonymously: signInAnonymouslyH2H,
        getCurrentUserUid,
      }
    }
  }, [])

  return <>{children}</>
}
